import api from "../axios";

export const getAllVenues = (data) => api.get("venue/venues/all", data);
export const ClientVenueDetails = (data) => api.get(`venue/${data}`, data);
